import React, { useState } from 'react'
import CSVReader from 'react-csv-reader'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import UploadAlert from '../Details/UploadAlert'
import { handleReUploadUserCSV } from '../../actions/reconciliationTypes'

const LoadedInvoiceProduct = ({ index, product, loadingCSV, loadedInvoice, handleReUploadUserCSV }) => {
  const handleFileUpload = (data, fileInfo) => {
    handleReUploadUserCSV(
      product.cW_Item_RecID,
      product.cW_Product_RecID,
      data,
      index,
      loadedInvoice.cwCompanyId,
      loadedInvoice.billingLogRecId
    )
  }
  const [rowOpen, setRowOpen] = useState(false)

  const handleFileUploadError = () => {}

  const parseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  }

  return (
    <React.Fragment>
      <tr key={index}>
        <td style={{ verticalAlign: 'middle' }}>{product.cW_Item_Desc}</td>
        {loadingCSV[index] ? (
          <td style={{ verticalAlign: 'middle' }}>uploading...</td>
        ) : (
          <React.Fragment>
            <td>
              <React.Fragment>
                <CSVReader
                  parserOptions={parseOptions}
                  cssClass="react-csv-input"
                  onFileLoaded={handleFileUpload}
                  onError={handleFileUploadError}
                  inputId="UserUpload"
                />
                {product.errorMessage && <span>Error uploading file, please try again</span>}
                {product.successMessage && <UploadAlert color="success">Uploaded successfully</UploadAlert>}
                {product.clearMessage && <UploadAlert color="primary">Upload Deleted</UploadAlert>}
              </React.Fragment>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              {product === null || product.users === null ? (
                <span>No Upload</span>
              ) : (
                <span>
                  {`${product.users && product.users.length ? product.users.length : 0} Users`}
                  <Button style={{ float: 'right' }} color="primary" size="sm" onClick={() => setRowOpen(!rowOpen)}>
                    {rowOpen ? 'Collapse' : 'Expand'}
                  </Button>
                </span>
              )}
            </td>
          </React.Fragment>
        )}
      </tr>
      {rowOpen && (
        <tr key={`$index-open`}>
          <td colSpan="5">
            {product && product.users && product.users.length > 0 ? (
              product.users.map((user, index) => <span style={{ display: 'inline-block', width: '33%' }}>{user}</span>)
            ) : (
              <span>no users found</span>
            )}
          </td>
        </tr>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  loadingCSV: state.recon.loadingCSV,
  loadedInvoice: state.recon.loadedInvoice,
})

const mapDispatchToProps = {
  handleReUploadUserCSV,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadedInvoiceProduct)
